<!-- <div class="modal solid open">
  <div (click)="close()" class="miniClose cancel icon-HamburgerAppClose"></div>
  <section id="header">
    <div class="title special certRequestTokenTitle">{{ isEditing ? 'Update Your Certificate Request Token' : 'Create Your Certificate Request Token' }}</div>
    <div class="subtitle">Certificate request tokens provide a secure, time-limited mechanism for generating client certificates without requiring direct API access. They act as pre-authorized tokens that contain certificate metadata and can be exchanged for actual client certificates. This is a one time token, once used it can't be reused. Find out more <a href="https://netfoundry.io/docs/frontdoor/learn/authentication/certificate-request-tokens" target="_blank">here.</a> </div>
  </section>

  <section id="header">
    <div class="row label">
      Name
    </div>
    <div class="row">
      <input
        placeholder="Name your certificate request token."
        [(ngModel)]="model.name"
        />
    </div>
    <div  class="row label">
      Common Name
      <span class="note">Optional</span>
    </div>
    <div    class="row">
      <input
        [disabled]=""
        placeholder="Add the common name."
        [(ngModel)]="model.commonName"
        />

    </div>
    <div class="row label">
      Organization
      <span class="note">Optional</span>
    </div>
    <div class="row">
      <input
        placeholder="Add the organization for your certificate request token."
        [(ngModel)]="model.organization"
        />

    </div>
    <div   class="row label">
      Organizational Unit
      <span class="note">Optional</span>
    </div>
    <div    class="row">
      <input
        [disabled]=""
        placeholder="Add your organizational unit."
        [(ngModel)]="model.organizationalUnit"
        />
    </div>
    <div   class="row label">
      Valid Years
      <span class="note">Optional</span>
    </div>
    <div    class="row">
      <input
        [disabled]=""
        placeholder="Number of years certificate will be valid. Maximum number of 10."
        [(ngModel)]="model.validYears"
        type="number"
        min="1"
        max="10"
        />
    </div>
    @if (isEditing) {
      <div class="row label">
        Share Link
      </div>
    }
    @if (isEditing) {
      <div style="cursor: pointer;" (click)="copyText(tokenURL)" class="row">
        <i (click)="copyText(tokenURL)" class="pi pi-copy" style="font-size: 1rem; cursor: pointer;"></i> {{tokenURL}}
      </div>
    }



    <div  style="padding-top: 20px !important; position: static;" class="row buttonRow right">
      <button  (click)="create()" class="save confirm" label="Save" >{{ isEditing ? 'Save' : 'Create' }}</button>
    </div>
  </section>
</div> -->

@if (isLoading) {
  <lib-loading-indicator [isLoading]="isLoading"></lib-loading-indicator>
}
<div class="projectable-form-wrapper frontdoor-form"
  (keyup.escape)="closeModal(false)"
    (keyup.enter)="save($event)"
  >
  <lib-form-header
    [data]="formData"
    [title]="isExistingEntity ? 'View Certificate Request Token: ' : 'Create New Certificate Request Token'"
    [moreActions]="moreActions"
    (actionRequested)="headerActionRequested($event)"
    [(formView)]="formView"
  ></lib-form-header>
  <div class="integration-form-container projectable-form-container">
    @if (formView === 'simple') {
      <div class="projectable-form-main-column form-group-row">
        <div class="form-group-column two-fifths">
          <lib-form-field-container [title]="'Certificate Request Token Details'">
            <div class="stacked-fields">
              <div class="field-row frontdoor-error-stack" [class.frontdoor-error-field]="nameError">
                <div class="field-label">
                  <span class="frontdoor-inline-error-group">
                    Certificate Request Token Name
                    <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="nameError">
                      {{ nameErrorMessage || 'Must not be empty' }}
                    </span>
                  </span>
                </div>
                <input
                  placeholder="Name your certificate request token"
                  [(ngModel)]="formData.name"
                />
              </div>

              <div class="field-row frontdoor-error-stack" [class.frontdoor-error-field]="commonNameError">
                <div class="field-label">
                  <span class="frontdoor-inline-error-group">
                    Common Name
                    <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="commonNameError">
                      {{ commonNameMessage || 'Invalid common name' }}
                    </span>
                  </span>
                  <span class="field-label-suffix">OPTIONAL</span>
                </div>
                <input
                  placeholder="Add the common name."
                  [(ngModel)]="formData.commonName"
                />
              </div>

              <div class="field-row frontdoor-error-stack" [class.frontdoor-error-field]="organizationError">
                <div class="field-label">
                  <span class="frontdoor-inline-error-group">
                    Organization
                    <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="organizationError">
                      {{ organizationMessage || 'Invalid organization' }}
                    </span>
                  </span>
                  <span class="field-label-suffix">OPTIONAL</span>
                </div>
                <input
                  placeholder="Add the organization for your certificate request token."
                  [(ngModel)]="formData.organization"
                />
              </div>

              <div class="field-row frontdoor-error-stack" [class.frontdoor-error-field]="organizationalUnitError">
                <div class="field-label">
                  <span class="frontdoor-inline-error-group">
                    Organizational Unit
                    <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="organizationalUnitError">
                      {{ organizationalUnitMessage || 'Invalid organizational unit' }}
                    </span>
                  </span>
                  <span class="field-label-suffix">OPTIONAL</span>
                </div>
                <input
                  placeholder="Add your organizational unit."
                  [(ngModel)]="formData.organizationalUnit"
                />
              </div>

              <div class="field-row frontdoor-error-stack" [class.frontdoor-error-field]="validYearsError">
                <div class="field-label">
                  <span class="frontdoor-inline-error-group">
                    Valid Years
                    <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="validYearsError">
                      {{ validYearsMessage || 'Invalid valid years value' }}
                    </span>
                  </span>
                  <span class="field-label-suffix">OPTIONAL</span>
                </div>
                <input
                  placeholder="Number of years certificate will be valid. Maximum number of 10."
                  [(ngModel)]="formData.validYears"
                  type="number"
                  min="1"
                  max="10"
                />
              </div>
            </div>
          </lib-form-field-container>

          @if (isEditing) {
          <lib-form-field-container [title]="'Share Link'" [label]="''">  
            <div style="cursor: pointer;" (click)="copyText(tokenURL)" class="row">
              <i (click)="copyText(tokenURL)" class="pi pi-copy" style="font-size: 1rem; cursor: pointer;"></i> {{tokenURL}}
            </div>
          </lib-form-field-container>
          }

      </div>
      </div>
    }
    @if (formView === 'raw') {
      <div class="form-group-column">
        @if (formData) {
          <lib-json-view [(data)]="formData"></lib-json-view>
        }
      </div>
    }

  </div>
</div>